$(document).ready(function(){$(".blog-slide").slick({infinite:!0,slidesToShow:5,slidesToScroll:1,centerMode:!1,arrows:!1,autoplay:!0,dots:!1,responsive:[{breakpoint:1200,settings:{autoplay:!0,arrows:!1,slidesToShow:4,slidesToScroll:1,dots:!1}},{breakpoint:992,settings:{autoplay:!0,arrows:!1,slidesToShow:3,slidesToScroll:1,dots:!1}},{breakpoint:576,settings:{autoplay:!0,arrows:!1,slidesToShow:1,slidesToScroll:1,dots:!1}}]}),$(".blog-pg-slider").slick({infinite:!0,slidesToShow:3,slidesToScroll:1,centerMode:!1,arrows:!1,autoplay:!0,dots:!1,responsive:[{breakpoint:768,settings:{autoplay:!0,arrows:!1,slidesToShow:2,slidesToScroll:1,dots:!1}},{breakpoint:481,settings:{autoplay:!0,arrows:!1,slidesToShow:1,slidesToScroll:1,dots:!1}}]}),$(".pro-collection-slider, .list-collections-default .collection-item .img-box .img-box-slider").slick({infinite:!1,slidesToShow:1,slidesToScroll:1,arrows:!1,dots:!0}),$(document).on("click",".product--main-slide img",function(){$(".popup-overlay, .popup-content").addClass("active");var o=$(this).parents(".product--main-slide").attr("data-slick-index");$("body").addClass("show-product-modal"),$(".promodal-slide-outer").slick("slickGoTo",o)}),$(document).on("click",".product-modal-close",function(){$(".popup-overlay, .popup-content").removeClass("active"),$("body").removeClass("show-product-modal")}),jQuery(".video_mod").on("hide.bs.modal",function(o){var s=jQuery(o.delegateTarget).find("iframe"),e=s.attr("src");s.attr("src","/empty.html"),s.attr("src",e)}),jQuery(".embed-responsive iframe").addClass("playyt_video"),jQuery("#ply_icon").on("click",function(o){jQuery(".playyt_video")[0].src+="&autoplay=1",o.preventDefault()}),$(".logo-block").slick({infinite:!0,slidesToShow:5,slidesToScroll:1,arrows:!1,dots:!1,autoplay:!0,autoplaySpeed:0,speed:8e3,pauseOnHover:!1,cssEase:"linear",responsive:[{breakpoint:992,settings:{autoplay:!0,autoplaySpeed:0,speed:8e3,pauseOnHover:!1,cssEase:"linear",arrows:!1,slidesToShow:3,slidesToScroll:1,dots:!1}},{breakpoint:768,settings:{autoplay:!0,arrows:!1,slidesToShow:2,slidesToScroll:1,dots:!1}},{breakpoint:576,settings:{autoplay:!0,arrows:!1,slidesToShow:2,variableWidth:!0,dots:!1}}]}),$(".home-testimonial-slider").slick({infinite:!0,slidesToShow:1,slidesToScroll:1,arrows:!0,autoplay:!0,centerMode:!1,dots:!0}),$(".product_slider").slick({infinite:!0,slidesToShow:3,slidesToScroll:1,arrows:!1,autoplay:!1,dots:!1,responsive:[{breakpoint:992,settings:{autoplay:!0,arrows:!1,dots:!1,slidesToShow:2,slidesToScroll:1}},{breakpoint:575,settings:{autoplay:!0,arrows:!1,dots:!1,slidesToShow:1,slidesToScroll:1}}]}),$(".doctor_reviews").slick({infinite:!0,slidesToShow:1,slidesToScroll:1,arrows:!1,autoplay:!0,dots:!1,focusOnSelect:!0,responsive:[{breakpoint:768,settings:{autoplay:!0,arrows:!1,slidesToShow:3,slidesToScroll:1,centerMode:!0,dots:!1}}]}),$(".skins_slider").slick({infinite:!0,slidesToShow:1,slidesToScroll:1,arrows:!1,dots:!1,asNavFor:".skins_slider_nav"}),$(".skins_slider_nav").slick({slidesToShow:4,slidesToScroll:1,asNavFor:".skins_slider",dots:!1,arrows:!1,centerMode:!1,focusOnSelect:!0,responsive:[{breakpoint:992,settings:{arrows:!0,slidesToShow:3,slidesToScroll:1,dots:!1}},{breakpoint:768,settings:{arrows:!0,slidesToShow:2,slidesToScroll:1,dots:!1}},{breakpoint:480,settings:{arrows:!0,slidesToShow:1,slidesToScroll:1,dots:!1}}]}),$(".compare_slider").slick({infinite:!0,slidesToShow:4,slidesToScroll:1,arrows:!1,draggable:!1,dots:!0,responsive:[{breakpoint:992,settings:{arrows:!1,slidesToShow:3,slidesToScroll:1,dots:!0}},{breakpoint:768,settings:{arrows:!1,slidesToShow:2,slidesToScroll:1,dots:!0}},{breakpoint:480,settings:{arrows:!1,slidesToShow:1,slidesToScroll:1,dots:!0}}]}),$(".timeline_slider").slick({infinite:!0,slidesToShow:3,slidesToScroll:1,arrows:!1,draggable:!1,dots:!0,responsive:[{breakpoint:992,settings:{arrows:!1,slidesToShow:2,slidesToScroll:1,dots:!0}},{breakpoint:768,settings:{arrows:!1,slidesToShow:2,slidesToScroll:1,dots:!0}},{breakpoint:480,settings:{arrows:!1,slidesToShow:1,slidesToScroll:1,dots:!0}}]}),

$('.home_video_slider').slick({
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true, 
  accessibility: true,
  swipeToSlide: false,
  draggable: false,
  autoplaySpeed: 4000,
  arrows: false,
  dots: true,
  cssEase:'linear'
});

$('.trustpilot-slider').slick({
  infinite: true,
  slidesToShow: 2, 
  slidesToScroll: 1, 
  arrows: false, 
  autoplay: true,
  autoplaySpeed: 2000,
  centerMode: true,
  dots: false,
  responsive: [
    {
      breakpoint: 1025,
      settings: {
        autoplay: true,
        autoplaySpeed: 2000,
        arrows: false,
        slidesToShow: 2, 
        slidesToScroll: 1,
        centerMode: true,
        centerPadding: '25%',
        dots: false,
      }
    },
    {
      breakpoint: 768,
      settings: {
        autoplay: true,
        autoplaySpeed: 2000,
        arrows: false,
        slidesToShow: 1, 
        slidesToScroll: 1,
        centerMode: true,
        centerPadding: '25%',
        dots: false,
      }
    }
  ]
});
  
  $(".product__main-photos .product-slideshow").slick({infinite:!0,slidesToShow:1,slidesToScroll:1,arrows:!1,dots:!1,asNavFor:".product__thumbs--scroller, .promodal-slide-outer"}),$(".product__thumbs--scroller").slick({infinite:!1,slidesToShow:8,slidesToScroll:1,vertical:!0,centerMode:!1,asNavFor:".product__main-photos .product-slideshow",arrows:!0,dots:!1,focusOnSelect:!0,responsive:[{breakpoint:1200,settings:{arrows:!0,slidesToShow:5,slidesToScroll:1,arrows:!0,dots:!1}},{breakpoint:992,settings:{arrows:!0,slidesToShow:8,slidesToScroll:1,arrows:!0,dots:!1}},{breakpoint:768,settings:{arrows:!0,slidesToShow:6,slidesToScroll:1,arrows:!0,dots:!1}},{breakpoint:481,settings:{arrows:!0,slidesToShow:4,slidesToScroll:1,dots:!1}}]}),$(".promodal-slide-outer").slick({infinite:!0,slidesToShow:1,slidesToScroll:1,arrows:!0,dots:!1}),$(".custom-pro-recomn-slider").slick({infinite:!0,slidesToShow:5,slidesToScroll:1,autoplay:!1,autoplaySpeed:3e3,arrows:!1,dots:!1,responsive:[{breakpoint:992,settings:{arrows:!1,slidesToShow:3,slidesToScroll:1,dots:!1}},{breakpoint:768,settings:{arrows:!1,slidesToShow:2,slidesToScroll:1}},{breakpoint:576,settings:{arrows:!1,centerMode:!0,slidesToShow:1,slidesToScroll:1}}]}),$(".product_thumb_slider").slick({infinite:!0,slidesToShow:1,slidesToScroll:1,autoplay:!1,autoplaySpeed:3e3,centerMode:!1,arrows:!1,dots:!0}),$(".product-videos-inner").slick({infinite:!0,slidesToShow:1,slidesToScroll:1,arrows:!1,autoplaySpeed:3e3,autoplay:true,dots:!0}),$(".sauna_lamobile").slick({infinite:!1,slidesToShow:4,slidesToScroll:1,autoplay:!1,autoplaySpeed:3e3,centerMode:!1,arrows:!1,dots:!1,vertical:!0,focusOnSelect:!0,asNavFor:".sauna_lamobile_content"}),$(".sauna_lamobile_content").slick({infinite:!0,slidesToShow:1,slidesToScroll:1,autoplay:!1,autoplaySpeed:3e3,centerMode:!1,arrows:!0,dots:!1,asNavFor:".sauna_lamobile"}),$(".accordion_before .card-header h5").click(function(){$(".accordion_before .card").removeClass("active"),$(this).parents(".card").addClass("active")}),$(".tabs-nav li:first-child").addClass("active"),$(".tab-content").hide(),$(".tab-content:first").show(),$(".tabs-nav li").click(function(){$(".tabs-nav li").removeClass("active"),$(this).addClass("active"),$(".tab-content").hide();var o=$(this).find("a").attr("href");return $(o).fadeIn(),!1}),"challenge"==$("body").attr("id")&&$(".site-header.header-parallax").addClass("header_background"),$(".treatment_tab_nav ul.nav-tabs li.nav-item button").each(function(){var o=$(this).text().toLowerCase();localStorage.getItem("cols")==o&&$(this).trigger("click")}),$(".skin_treatment ul li.skin_item a").click(function(o){var s=$(this).text().toLowerCase();localStorage.setItem("cols",s)}),$(".treatment_tab_nav ul.nav-tabs li.nav-item button").click(function(o){var s=$(this).text().toLowerCase();localStorage.setItem("cols",s)}),$(".btnNext").click(function(){$(".nav-tabs .active").parent().next("li").find("button").trigger("click")}),$(".btnPrevious").click(function(){$(".nav-tabs .active").parent().prev("li").find("button").trigger("click")}),$(".product-ads-slide").slick({infinite:!0,slidesToShow:1,slidesToScroll:1,arrows:!1,dots:!1,autoplay:!0,autoplaySpeed:0,speed:8e3,variableWidth:!0,pauseOnHover:!1,cssEase:"linear"});var o=$("<input>"),s=window.location.href;$(".link-copied").on("click",function(){$("body").append(o),o.val(s).select(),document.execCommand("copy"),o.remove()}),$(".blog-filter ul li a").click(function(){$(".blog-filter ul li").removeClass("active"),$(this).parent().addClass("active");var o=$(this).attr("data-target");$(".blog-posts-wrap").hide(),$(".blog-recent-pots .blog-item").hide(),$('.blog-posts-wrap[data-target="'+o+'"]').show(),$('.blog-recent-pots .blog-item[data-target="'+o+'"]').show()})}),$(".contact-us-page #term").change(function(){$(this).is(":checked")?$('button[type="submit"]').prop("disabled",!1):$('button[type="submit"]').prop("disabled",!0)}); 
$(document).ready(function(){
AOS.init({
  duration: 1000
});

$(".m-0").click(function(){
  $(".mode-2, .mode-3").removeClass("active");
  $(".mode-1").toggleClass("active");
  
});
$(".m-1").click(function(){
  $(".mode-1, .mode-3").removeClass("active");
  $(".mode-2").toggleClass("active");
  
});
$(".m-2").click(function(){
  $(".mode-1, .mode-2").removeClass("active");
  $(".mode-3").toggleClass("active");
  
});

$('.home-vslider').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: false,
  infinite: true,
  speed: 300,
  dots: true,
});

$('.step-sliders').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: false,
  infinite: true,
  speed: 300,
  dots: false,
});
  

$('.neuro-slider').slick({
  dots: false,
  arrow: false,
  infinite: true,
  speed: 300,
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        arrow: false,
        autoplay: false,
        dots: false,
      }
    },
    {
      breakpoint: 576,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode:true,
        arrow: false,
        autoplay: false
      }
    }
  ]
});
  
$('.testimonial-col').slick({
  dots: false,
  arrow: false,
  infinite: true,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1367,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        dots: false,
        autoplay: false
      }
    },
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        autoplay: false
      }
    },
    {
      breakpoint: 681,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: false,
        centerMode:true
      }
    }
  ]
});
$('.expert-slider').slick({
  dots: false,
  arrow: false,
  infinite: true,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1367,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: false,
        dots: false
      }
    },
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        autoplay: false,
      }
    },
    {
      breakpoint: 576,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: false,
        centerMode:true,
      }
    }
  ]
});


});  